import { get } from 'wtb-utils';

const url = process.env.REACT_APP_MAINTENANCE_URL;

function getVersions() {
  return get(`${url}/version`);
}

export {
  getVersions
};
